import { TranslatedTerms } from "../../globals/TranslatedTerms";
import { DefaultId, DefaultPersonalAccountId } from "../../shared/Globals";
import { TranslationDictionary } from "../../shared/Language";
import { InvestmentActivityTypes } from "../../shared/UI";


export const UiDictionary: TranslationDictionary = {
    [TranslatedTerms.LOGIN]: {
        [DefaultId]: "Login",
        "da": "Log ind"
    },
    [TranslatedTerms.SIGNUP]: {
        [DefaultId]: "Create account",
        "da": "Opret konto"
    },
    [TranslatedTerms.MFA]: {
        [DefaultId]: "Multi-Factor authentication",
        "da": "2-Faktor godkendelse"
    },
    [TranslatedTerms.FORGOT_PASSWORD]: {
        [DefaultId]: "Forgot password",
        "da": "Glemt password"
    },
    [TranslatedTerms.SETUP_NEW_PASSWORD]: {
        [DefaultId]: "Setup new password",
        "da": "Opret nyt password"
    },
    [TranslatedTerms.HOME]: {
        [DefaultId]: "Dashboard",
        "da": "Dashboard"
    },
    [TranslatedTerms.PROFILE]: {
        [DefaultId]: "Profile",
        "da": "Profil"
    },
    [TranslatedTerms.PROJECTS]: {
        [DefaultId]: "Projects",
        "da": "Projekter"
    },
    [TranslatedTerms.FEED]: {
        [DefaultId]: "News feed",
        "da": "Nyhedsfeed"
    },
    [TranslatedTerms.CONTACT]: {
        [DefaultId]: "Contact",
        "da": "Kontakt"
    },
    [TranslatedTerms.CONTRACT]: {
        [DefaultId]: "Contract",
        "da": "Kontrakt"
    },
    [TranslatedTerms.MONTHS]: {
        [DefaultId]: "Months",
        "da": "Måneder"
    },
    [TranslatedTerms.RETURN_PAYMENT_DATE]: {
        [DefaultId]: "Return date",
        "da": "Tilbebetalt dato"
    },
    [TranslatedTerms.PROJECT_START]: {
        [DefaultId]: "Project start",
        "da": "Projekt start"
    },
    [TranslatedTerms.PROJECT_END]: {
        [DefaultId]: "Project end",
        "da": "Projekt slut"
    },
    [TranslatedTerms.UNKNOWN]: {
        [DefaultId]: "Unknown",
        "da": "Ukendt"
    },
    [TranslatedTerms.GO_BACK]: {
        [DefaultId]: "Go back",
        "da": "Gå tilbage"
    },
    [TranslatedTerms.WHERE_HAVE_YOU_HEARD_ABOUT_FUNDBRICKS]: {
        [DefaultId]: "Where have you heard about Fundbricks?",
        "da": "Hvor har du hørt om Fundbricks?"
    },
    [TranslatedTerms.NAME_OF_FUNDBRICKS_REP]: {
        [DefaultId]: "Select Fundbricks representative",
        "da": "Vælg Fundbricks repræsentant"
    },
    [TranslatedTerms.DEPOSIT_RECIVED]: {
        [DefaultId]: "Deposit received",
        "da": "Depositum modtaget"
    },
    [TranslatedTerms.CONTRACT_SIGNED]: {
        [DefaultId]: "Contract signed",
        "da": "Kontrakt er underskrevet"
    },
    [TranslatedTerms.SIGN_CONTRACT]: {
        [DefaultId]: "Sign contract",
        "da": "Underskriv kontrakt"
    },
    [TranslatedTerms.FAQ]: {
        [DefaultId]: "FAQ",
        "da": "FAQ"
    },
    [TranslatedTerms.GENERAL]: {
        [DefaultId]: "General",
        "da": "Generelt"
    },
    [TranslatedTerms.SUPPORT]: {
        [DefaultId]: "Support",
        "da": "Hjælp"
    },
    [TranslatedTerms.USER_POLICY]: {
        [DefaultId]: "Terms of use",
        "da": "Brugerbetingelser"
    },
    [TranslatedTerms.PRIVACY_POLICY]: {
        [DefaultId]: "Privacy Policy",
        "da": "Privatlivspolitik"
    },
    [TranslatedTerms.RISK_POLICY]: {
        [DefaultId]: "Risk description",
        "da": "Risikobeskrivelse"
    },
    [TranslatedTerms.COOKIE_POLICY]: {
        [DefaultId]: "Cookie terms",
        "da": "Cookievilkår"
    },
    [TranslatedTerms.LOG_OUT]: {
        [DefaultId]: "Sign out",
        "da": "Log ud"
    },
    [TranslatedTerms.MENU]: {
        [DefaultId]: "Menu",
        "da": "Menu"
    },
    [TranslatedTerms.CLOSE_MENU]: {
        [DefaultId]: "Close menu",
        "da": "Skjul menu"
    },
    [TranslatedTerms.FILE_FOR]: {
        [DefaultId]: "The file for",
        "da": "Filen til"
    },
    [TranslatedTerms.IS_UPLOADED]: {
        [DefaultId]: "Is uploaded",
        "da": "Er uploaded"
    },
    [TranslatedTerms.SEND_FOR_APPROVAL]: {
        [DefaultId]: "Send for approval",
        "da": "Send til godkendelse"
    },
    [TranslatedTerms.COMPLETE_INVESTMENT]: {
        [DefaultId]: "Complete investment",
        "da": "Færdiggør investering"
    },
    [TranslatedTerms.COMPLETE_PROFILE]: {
        [DefaultId]: "Complete profile",
        "da": "Færdiggør profil"
    },
    [TranslatedTerms.ACCEPT_NEWSLETTER_DESCRIPTION]: {
        [DefaultId]: "Sign up for our newsletter",
        "da": "Tilmeld dig nyhedsbrevet"
    },
    [TranslatedTerms.ACCEPT_TERMS_DESCRIPTION]: {
        [DefaultId]: "Accept terms and conditions",
        "da": "Accepter brugerbetingelser"
    },
    [TranslatedTerms.READ_MORE]: {
        [DefaultId]: "Read more",
        "da": "Læs mere "
    },
    [TranslatedTerms.AND_A_LAST_THING]: {
        [DefaultId]: "and a last thing",
        "da": "og lige det sidste"
    },
    [TranslatedTerms.NAME_CONTRY_LANGUAGE_DESCRIPTION]: {
        [DefaultId]: "We need your name, the country where you live and your preferred language",
        "da": "Vi skal bruge dit navn, det land hvor du har bopæl og dit fortrukkende sprog"
    },
    [TranslatedTerms.RESET_USER]: {
        [DefaultId]: "Reset user",
        "da": "Nulstil bruger"
    },
    [TranslatedTerms.RESET_USER_WARNING_DESCRIPTION]: {
        [DefaultId]: "This action will force you to redo the KYC process",
        "da": "Denne handling vil tvinge dig til at gentage KYC-processen"
    },
    [TranslatedTerms.RESET_USER_DESCRIPTION]: {
        [DefaultId]: "This action allow you to change your registered name and country",
        "da": "Denne handling giver dig mulighed for at ændre dit registrerede navn og land"
    },
    [TranslatedTerms.ARE_YOU_SURE]: {
        [DefaultId]: "Are you sure",
        "da": "Er du sikker"
    },
    [TranslatedTerms.SELECT_ONE]: {
        [DefaultId]: "Select",
        "da": "Vælg"
    },
    [TranslatedTerms.CANCEL]: {
        [DefaultId]: "Cancel",
        "da": "Annuller"
    },
    [TranslatedTerms.FILL_DATA]: {
        [DefaultId]: "Fill data",
        "da": "Udfyld data"
    },
    [TranslatedTerms.AWAIT_APPROVAL]: {
        [DefaultId]: "Awaiting approval",
        "da": "Afvent godkendelse"
    },
    [TranslatedTerms.APPROVED]: {
        [DefaultId]: "Approved",
        "da": "Godkendt"
    },
    [TranslatedTerms.KYC_INCOMPLETE_MESSAGE]: {
        [DefaultId]: "You're missing some fields. We can't start the review process until all fields are filled.",
        "da": "Du mangler nogle felter. Vi kan ikke starte gennemgangsprocessen, før alle felter er udfyldt."
    },
    [TranslatedTerms.KYC_PENDING_MESSAGE]: {
        [DefaultId]: "Your data is being review. Results are ready within 1-3 days.",
        "da": "Dine data gennemgås. Resultaterne er klar i løbet af 1-3 dage."
    },
    [TranslatedTerms.NEXT]: {
        [DefaultId]: "Next",
        "da": "Næste"
    },
    [TranslatedTerms.BACK]: {
        [DefaultId]: "Back",
        "da": "Tilbage"
    },
    [TranslatedTerms.RELOAD]: {
        [DefaultId]: "Update page",
        "da": "Genindlæs siden"
    },
    [TranslatedTerms.PROBLEMS_OPENING_THE_LINK_CLICK_HERE]: {
        [DefaultId]: "Problems opening the link? Click here or copy this link and insert in your browser:",
        "da": "Problemer med at åbne linket? Klik her eller kopier linket og indsæt i din browser: "
    },
    [TranslatedTerms.OPEN_CONTRACT]: {
        [DefaultId]: "Go to contract",
        "da": "Gå til kontrakt"
    },
    [TranslatedTerms.GO_BACK_TO_FEED]: {
        [DefaultId]: "Go back to feed",
        "da": "Gå tilbage til feed"
    },
    [TranslatedTerms.CREATED]: {
        [DefaultId]: "Created",
        "da": "Oprettet"
    },
    [TranslatedTerms.DETAILS]: {
        [DefaultId]: "Details",
        "da": "Detaljer"
    },
    [TranslatedTerms.AMOUNT]: {
        [DefaultId]: "Amount",
        "da": "Beløb"
    },
    [TranslatedTerms.BANK]: {
        [DefaultId]: "Bank",
        "da": "Bank"
    },
    [TranslatedTerms.INCOMPLETE]: {
        [DefaultId]: "Incomplete",
        "da": "Ikke gennemført"
    },
    [TranslatedTerms.BANK_ACCOUNT]: {
        [DefaultId]: "Bank account",
        "da": "Bank konto"
    },
    [TranslatedTerms.PAYMENT_REFERENCE]: {
        [DefaultId]: "Payment reference",
        "da": "Betalings reference"
    },
    [TranslatedTerms.PAYMENT_REFERENCE_TOOLTIP]: {
        [DefaultId]: "Please add this reference to your bank-transfer",
        "da": "Venligst tilføj denne refrence i din bank-overførsel"
    },
    [TranslatedTerms.PAYMENT_DEADLINE]: {
        [DefaultId]: "Payment deadline",
        "da": "Indbetalingsfrist"
    },
    [TranslatedTerms.PAYMENT_DEADLINE_DESCRIPTION]: {
        [DefaultId]: "You will receive an email when you need to deposit",
        "da": "Du vil modtage en mail når du skal indbetale"
    },
    [TranslatedTerms.AMOUNT_INSUFFICIENT]: {
        [DefaultId]: "Amount insufficient",
        "da": "Beløbet er utilstrækkeligt"
    },
    [TranslatedTerms.SEE_PROJECT_DETAILS]: {
        [DefaultId]: "See project details",
        "da": "Se projekt-detaljer"
    },
    [InvestmentActivityTypes.CreateInvestment]: {
        [DefaultId]: "New investment in project {project} as been drafted.",
        "da": "Ny investering påbegyndt i projektet {project}."
    },
    [DefaultPersonalAccountId]: {
        [DefaultId]: "Personal account",
        "da": "Personlig konto"
    },
    [TranslatedTerms.LATEST_INVESTMENT]: {
        [DefaultId]: "Latest investment",
        "da": "Seneste investering"
    },
    [TranslatedTerms.ACCOUNT_VALUE]: {
        [DefaultId]: "Account value",
        "da": "Kontoværdi"
    },
    [TranslatedTerms.ALL_ACCOUNTS]: {
        [DefaultId]: "All accounts",
        "da": "Alle konti"
    },
    [TranslatedTerms.SELECT_ACCOUNT]: {
        [DefaultId]: "Select account",
        "da": "Vælg konto"
    },
    [TranslatedTerms.INVEST]: {
        [DefaultId]: "Invest",
        "da": "Investér"
    },
    [TranslatedTerms.CREATE_NEW_ACCOUNT]: {
        [DefaultId]: "Create new account",
        "da": "Opret ny konto"
    },
    [TranslatedTerms.COMPANY_ACCOUNT]: {
        [DefaultId]: "Company account",
        "da": "Firma konto"
    },
    [TranslatedTerms.PAID_BACK_INVESTMENTS]: {
        [DefaultId]: "Completed investments",
        "da": "Afsluttede investeringer"
    },
    [TranslatedTerms.ACTIVE_INVESTMENTS]: {
        [DefaultId]: "Active investments",
        "da": "Aktive investeringer"
    },
    [TranslatedTerms.FOLLOW]: {
        [DefaultId]: "Follow",
        "da": "Følg"
    },
    [TranslatedTerms.FOLLOWING]: {
        [DefaultId]: "Following",
        "da": "Følger"
    },
    [TranslatedTerms.SUBSCRIPTION_LIST]: {
        [DefaultId]: "News channels",
        "da": "Nyhedskanaler"
    },
    [TranslatedTerms.PROJECT_NEWS]: {
        [DefaultId]: "Project news",
        "da": "Projektnyheder"
    },
    [TranslatedTerms.NO_MORE_NEWS]: {
        [DefaultId]: "No posts ...",
        "da": "Ingen nyheder ..."
    },

    [TranslatedTerms.GO_TO_PROJECT]: {
        [DefaultId]: "Go to project",
        "da": "Gå til projekt"
    },
    [TranslatedTerms.GO_TO_DASHBOARD]: {
        [DefaultId]: "Go to dashboard",
        "da": "Gå til dashboard"
    },
    [TranslatedTerms.GO_TO_DETAILS]: {
        [DefaultId]: "Go to details",
        "da": "Se detaljer"
    },
    [TranslatedTerms.EXPECTED_RETURN]: {
        [DefaultId]: "Expected interest",
        "da": "Forventet rente"
    },
    [TranslatedTerms.VALUE]: {
        [DefaultId]: "Value",
        "da": "Værdi"
    },
    [TranslatedTerms.VOLUME]: {
        [DefaultId]: "Volume",
        "da": "Volume"
    },
    [TranslatedTerms.STATUS]: {
        [DefaultId]: "Status",
        "da": "Status"
    },
    [TranslatedTerms.PROJECT]: {
        [DefaultId]: "Project",
        "da": "Projekt"
    },
    [TranslatedTerms.ACTIVITY]: {
        [DefaultId]: "Activity",
        "da": "Aktivitet"
    },
    [TranslatedTerms.NO_ACTIVITY]: {
        [DefaultId]: "No activity",
        "da": "Ingen aktivitet endnu"
    },
    [TranslatedTerms.DATE]: {
        [DefaultId]: "Date",
        "da": "Dato"
    },
    [TranslatedTerms.DASHBOARD_DESCRIPTION]: {
        [DefaultId]: "This is your personal dashboard, when you've completed your fist investment you will see all the details here.",
        "da": "Dette er dit personlige dashboard, efter at du har gennemført din første investering vil du kunne se alle detaljerne her."
    },
    [TranslatedTerms.WELCOME_TO_FUNDBRICKS]: {
        [DefaultId]: "Welcome to Fundbricks.com",
        "da": "Velkommen til Fundbricks.com"
    },
    [TranslatedTerms.NO_INVESTMENTS]: {
        [DefaultId]: "No investments",
        "da": "Ingen investeringer endnu"
    },
    [TranslatedTerms.NO_COMPLETED_INVESTMENTS]: {
        [DefaultId]: "No completed investments",
        "da": "Ingen gennemførte investeringer"
    },
    [TranslatedTerms.INVESTED_PROJECTS]: {
        [DefaultId]: "Invested projects",
        "da": "Investerede projekter"
    },
    [TranslatedTerms.PROFILE_PAGE_DESCRIPTION]: {
        [DefaultId]: "Here you can manage information for your various accounts. Updating data will not update the data already associated with an investments.",
        "da": "Her kan du administrere oplysninger til dine forskellige konti. Opdatering af data vil ikke opdatere de data, der allerede er knyttet til en investering."
    },
    [TranslatedTerms.HOW_DOES_IT_WORK]: {
        [DefaultId]: "How does it work?",
        "da": "Hvordan virker det?"
    },
    [TranslatedTerms.SEE_PROJECT]: {
        [DefaultId]: "See project",
        "da": "Se projektet"
    },
    [TranslatedTerms.BUILDING_FINANCEING]: {
        [DefaultId]: "Construction financing",
        "da": "Byggefinansiering"
    },
    [TranslatedTerms.SHARE_VIA]: {
        [DefaultId]: "Share via",
        "da": "Del via"
    },
    [TranslatedTerms.VIEW_DETAILS]: {
        [DefaultId]: "View details",
        "da": "Se detaljer"
    },
    [TranslatedTerms.DESIRED_LENDING_AMOUNT]: {
        [DefaultId]: "Desired amount",
        "da": "Ønsket udlånsbeløb"
    },
    [TranslatedTerms.COMPLETED]: {
        [DefaultId]: "Completed",
        "da": "Gennemført"
    },
    [TranslatedTerms.INTEREST_CALCULATED_BASED_ON_X_MONTHS]: {
        [DefaultId]: "This interest rate is calculated based on {X} months duration",
        "da": "Renten er beregnet ud fra {X} måneders løbetid"
    },
    [TranslatedTerms.INTEREST_CALCULATED_BASED_ON_AVAGE_MONTHS]: {
        [DefaultId]: "This interest rate is calculated based on avarge project duration",
        "da": "Renten er beregnet ud fra gennemsnitlig antal måneders løbetid"
    },
    [TranslatedTerms.ONBOARDING_ERROR_FIELDS_MESSAGE]: {
        [DefaultId]: "Please fill out firstname, lastname, phone and country",
        "da": "Venligst udfyld fornavn, efternavn, telefonnummer og land"
    },
    [TranslatedTerms.ONBOARDING_ERROR_CONTRY_MESSAGE]: {
        [DefaultId]: "Please fill out contry and language",
        "da": "Venligst udfyld land og sprog"
    },
    [TranslatedTerms.ONBOARDING_ERROR_TERMS_MESSAGE]: {
        [DefaultId]: "Please accept the terms and conditions",
        "da": "Venligst accepter brugerbettingelser"
    },
    [TranslatedTerms.DELETE]: {
        [DefaultId]: "Delete",
        "da": "Slet"
    },
    [TranslatedTerms.NOTIFICATIONS]: {
        [DefaultId]: "Notifications",
        "da": "Notifikationer"
    },
    [TranslatedTerms.LOW]: {
        [DefaultId]: "Low",
        "da": "Lav"
    },
    [TranslatedTerms.MEDIUM]: {
        [DefaultId]: "Medium"
    },
    [TranslatedTerms.HIGH]: {
        [DefaultId]: "High",
        "da": "Høj"
    },
    [TranslatedTerms.DONTKNOW]: {
        [DefaultId]: "Don't know",
        "da": "Ved ikke"
    },
    [TranslatedTerms.NO]: {
        [DefaultId]: "No",
        "da": "Nej"
    },
    [TranslatedTerms.YES]: {
        [DefaultId]: "Yes",
        "da": "Ja"
    },
    [TranslatedTerms.ADD]: {
        [DefaultId]: "Add",
        "da": "Tilføj"
    },
    [TranslatedTerms.DOWNLOAD_CENTRAL_INVESTORINFORMATION]: {
        [DefaultId]: "Get central investorinformation",
        "da": "Hent central investorinformation"
    },
    [TranslatedTerms.MESSAGES]: {
        [DefaultId]: "Messages",
        "da": "Beskeder"
    },
    [TranslatedTerms.MORARENTE]: {
        [DefaultId]: "Late payment interest",
        "da": "Morarente"
    },
    [TranslatedTerms.INVESTMENT_LOSS_DESCRIPTION]: {
        [DefaultId]: "We have sent the information about the project’s status to you via email. You are always welcome to contact Fundbricks.com for further assistance.",
        "da": "Vi har sendt informationen om projektets status til dig via e-mail. Du er altid velkommen til at kontakte Fundbricks.com for yderligere assistance."
    },
    [TranslatedTerms.PROJECT_FAILED_PROCESS]: {
        [DefaultId]: "Project in liquidation",
        "da": "Projektet er under afvikling"
    }
}
